import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ALERT_ERRORS } from 'src/app/core/constants/Errors';
import { ALERT_ICON_CONSTANTS, API_PATHS, debugLog, FLUTTER_POST_MESSAGE_TO_SEND, FLUTTER_POST_MESSAGE_TYPES, GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { Payment, Transaction } from 'src/app/models';
import { AlertService } from 'src/app/services/alert.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-embebed-transfiya',
  templateUrl: './transfiya.component.html',
  styleUrls: ['./transfiya.component.scss'],
})
export class TransfiyaComponent implements OnInit {
  @Output() TRANSFIYA = new EventEmitter();
  @Input() paymentInfo: Payment;
  @Input() transaction: Transaction;

  @HostListener('document:click', ['$event'])
  onDocumentClick = () => {
    this.notifyOnDocumentClick();
  };

  loading = true;
  displayMessage = false;
  iframeUrl: string = '';
  transfiyaIframeElement: HTMLIFrameElement;
  loadingMessage = GENERAL_CONSTANTS.TRANSACTION_LOADING_STATUS_MESSAGES.PROCESSING_TRANSACTION;

  constructor(private tokenService: TokenServiceService, private alertService: AlertService, private router: Router) {}

  ngOnInit() {
    this.iframeUrl = `${environment.modulesPayvalidaUrl}${API_PATHS.transfiyaForm}`;
    this.onActivate();
  }

  /**
   * @description Function to change the payment method
   * @returns
   */
  changeMethod = () => this.TRANSFIYA.emit();

  onActivate() {
    window.scroll(0, 0);

    window.addEventListener('message', async (event) => {
      if (event.origin !== environment.modulesPayvalidaUrl) return;

      let data = JSON.parse(event.data);

      if (data.src !== API_PATHS.transfiyaForm && data.type !== FLUTTER_POST_MESSAGE_TYPES.PLATFORM) return;

      switch (data.type) {
        case FLUTTER_POST_MESSAGE_TYPES.PLATFORM:
          this.transfiyaIframeElement = document.getElementById('transfiyaIframe') as HTMLIFrameElement;

          this.transfiyaIframeElement?.contentWindow?.postMessage(JSON.stringify({ type: FLUTTER_POST_MESSAGE_TO_SEND.LOAD_WEB_SCRIPT }), environment.modulesPayvalidaUrl);

        case FLUTTER_POST_MESSAGE_TYPES.IS_LOADING:
          this.loading = data.data;
          if (!this.loading && !this.displayMessage) this.displayMessage = true;

          break;
        case FLUTTER_POST_MESSAGE_TYPES.FORM_READY:
          this.transaction = this.tokenService.getAndDecodeToken();

          let userInformation = {
            country_code: +this.transaction.COUNTRY_CODE,
            user_phone: this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.contact_information?.phone ?? '',
            session_token: this.tokenService.getToken(),
            currency_code: this.transaction.ORDER_CURRENCY,
          };

          this.transfiyaIframeElement?.contentWindow?.postMessage(
            JSON.stringify({
              type: FLUTTER_POST_MESSAGE_TO_SEND.SET_USER_INFORMATION,
              data: userInformation,
            }),
            environment.modulesPayvalidaUrl
          );

          break;
        case FLUTTER_POST_MESSAGE_TYPES.ERROR:
          this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.WARNING);

          break;
        case FLUTTER_POST_MESSAGE_TYPES.CONTENT_SIZE:
          this.transfiyaIframeElement?.setAttribute('height', data.data);

          break;
        case FLUTTER_POST_MESSAGE_TYPES.STATUS_CHANGE:
          /// TODO: Pending implement "status change" logic
          debugLog('STATUS_CHANGE');
          break;
        case FLUTTER_POST_MESSAGE_TYPES.SCROLL:
          if (screen.width < 768) {
            window.scrollBy(0, data.data);

            break;
          }

          let scrollable: any = document.getElementsByClassName('methodInfo')[0];
          scrollable.scrollBy(0, data.data);

          break;
        case FLUTTER_POST_MESSAGE_TYPES.COMPLETE:
          this.router.navigate(['transfiya/alert'], { queryParams: { token: this.tokenService.getToken(), transfer_ID: data.transferID } });

          break;
        default:
          break;
      }
    });
  }

  /**
   * @description: Function to notify the iframe when the document is clicked
   */
  notifyOnDocumentClick(): void {
    let userInformation = {
      country_code: +this.transaction.COUNTRY_CODE,
      user_phone: this.transaction.ADDITIONAL_INFORMATION?.client?.personal_information?.contact_information?.phone ?? '',
      session_token: this.tokenService.getToken(),
      currency_code: this.transaction.ORDER_CURRENCY,
    };

    this.transfiyaIframeElement?.contentWindow?.postMessage(
      JSON.stringify({
        type: FLUTTER_POST_MESSAGE_TO_SEND.SET_USER_INFORMATION,
        data: userInformation,
      }),
      environment.modulesPayvalidaUrl
    );
  }
}
